import { selectAll } from 'helpers/dom'

const handleBfcacheVideo = () => {
  const videoEls = selectAll('video-player')

  if (videoEls.length) {
    videoEls.forEach((video) => {
      if (video.isLoaded) {
        video.onPause()

        setTimeout(() => {
          video.onPlay()
        }, 500)
      }
    })
  }
}

const handleBfcacheScroll = () => {
  const scrollPositionKey = `scrollPosition_${GM_STATE.customs.collectionHandle}`
  const scrollPosition = sessionStorage.getItem(scrollPositionKey)

  if (scrollPosition && scrollPosition < document.documentElement.scrollHeight) {
    window.scrollTo({
      top: parseInt(scrollPosition, 10),
      behavior: 'smooth'
    })
    sessionStorage.removeItem(scrollPositionKey)
  }
}

window.addEventListener('pageshow', (event) => {
  if (event.persisted) {
    handleBfcacheVideo()
    handleBfcacheScroll()
  }
})
